export const listStatus = [
    {name: 'Waiting', value: 'waiting'},
    {name: 'Updated', value: 'updated'}
]

export const listProductionStatus = [
    {value: 'pending', name: 'Pending'},
    {value: 'in_production', name: 'In production'},
    {value: 'cancelled', name: 'Cancelled'},
    {value: 'on-hold', name: 'On hold'},
    {value: 'packaged', name: 'Packaged'},
    {value: 'labelled', name: 'Labelled'},
    {value: 'cancel-ship', name: 'Cancel ship'},
    {value: 'false_design', name: 'False design'},
    {value: 'manual-package', name: 'Manual Package'}
]

export const listCurrentStatusFAC = [
    {value: 'pending', name: 'Pending'},
    {value: 'in_production', name: 'In production'},
    {value: 'cancelled', name: 'Cancelled'},
    {value: 'on-hold', name: 'On hold'},
    {value: 'packaged', name: 'Packaged'},
    {value: 'labelled', name: 'Labelled'},
    {value: 'cancel-ship', name: 'Cancel ship'},
    {value: 'false_design', name: 'False design'},
    {value: 'manual-package', name: 'Manual Package'}
]

export const listCurrentStatus3D = [
    {name: 'Chưa in', value: 'unprinted',},
    {name: 'Đã đẩy', value: 'pushed',},
    {name: 'Đã in', value: 'printed',},
    {name: 'Đã ép', value: 'transferred',},
    {name: 'QC sau ép', value: 'confirmed',},
    {name: 'Đang may', value: 'sewing',},
    {name: 'Hoàn thành', value: 'completed',},
    {name: 'Đã ship', value: 'shipped',}
]

export const listSource = [
    {name: 'Factory', value: 'fac'},
    {name: 'Fulfillment', value: 'ffm'},
    {name: 'Tool3D', value: 'tool3d'}
]

export const forcedUpdate = [
    {name: 'Tất cả', value: ''},
    {name: 'Yes', value: true},
    {name: 'No', value: false}
]

export const productionStatus = [
    {name: 'Tất cả', value: ''},
    {name: 'Đã sản xuất lại', value: true},
    {name: 'Chưa sản xuất lại', value: false}
]
